import { Link } from "react-router-dom";
import { useStore } from "@/context/StoreContext";
import { fileUrl } from "@/api";
import { Instagram, Facebook, Phone, Music2, MapPin, Clock } from "lucide-react";

export default function Footer() {
  const { settings } = useStore();
  const wa = settings?.whatsapp_number?.replace(/\D/g, "");
  return (
    <footer className="mt-24 border-t border-black/5" style={{ background: "var(--brand-surface)" }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3">
            {settings?.logo_url && (
              <img src={fileUrl(settings.logo_url)} alt="logo" className="h-12 w-12" />
            )}
            <span className="font-serif text-2xl font-bold">
              {settings?.business_name || "Floral Rossé"}
            </span>
          </div>
          <p className="text-sm text-neutral-500 mt-4 leading-relaxed">
            Flores artificiales premium y arreglos listos para eventos, salones de recepciones y decoración profesional.
          </p>
        </div>
        <div>
          <h4 className="font-serif text-lg mb-4">Catálogo</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/catalogo/packs" className="hover:text-[var(--brand-primary)]">Packs Florales</Link></li>
            <li><Link to="/catalogo/ramos" className="hover:text-[var(--brand-primary)]">Ramos</Link></li>
            <li><Link to="/catalogo/arreglos" className="hover:text-[var(--brand-primary)]">Arreglos terminados</Link></li>
            <li><Link to="/cotizacion" className="hover:text-[var(--brand-primary)]">Cotización B2B</Link></li>
            <li><Link to="/seguimiento" className="hover:text-[var(--brand-primary)]" data-testid="footer-track-link">Seguimiento de pedido</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-serif text-lg mb-4">Contacto</h4>
          <ul className="space-y-2 text-sm">
            {wa && (
              <li>
                <a href={`https://wa.me/${wa}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[var(--brand-accent)]">
                  <Phone size={14} /> {settings.whatsapp_number}
                </a>
              </li>
            )}
            {settings?.social?.instagram !== "" && <li className="flex items-center gap-2"><Instagram size={14} /> {settings?.social?.instagram || "@floralrosse"}</li>}
            {settings?.social?.facebook !== "" && <li className="flex items-center gap-2"><Facebook size={14} /> {settings?.social?.facebook || "Floral Rossé"}</li>}
            {settings?.social?.tiktok && <li className="flex items-center gap-2"><Music2 size={14} /> {settings.social.tiktok}</li>}
            {settings?.address && <li className="flex items-center gap-2"><MapPin size={14} /> {settings.address}</li>}
            {settings?.hours && <li className="flex items-center gap-2"><Clock size={14} /> {settings.hours}</li>}
          </ul>
        </div>
        <div>
          <h4 className="font-serif text-lg mb-4">B2B & Mayoristas</h4>
          <p className="text-sm text-neutral-500 leading-relaxed">
            Precios escalonados y entregas prioritarias para decoradores, eventistas y salones de recepciones.
          </p>
        </div>
      </div>
      <div className="border-t border-black/5 py-6 text-center text-xs text-neutral-500">
        © {new Date().getFullYear()} Floral Rossé · Hecho en Perú
      </div>
    </footer>
  );
}
